import api from '@Services/api';
import { AxiosResponse } from 'axios';
import {
	CRUDBase,
	DeleteSingleEntityPayload,
	GetAllMeta,
	GetSingleEntityPayload,
} from 'src/base/services/services.base';
import { PromoCode } from '../Types/PromoCodes.types';

/**
 * The backend's GetAll validator requires `sortBy.field` once the key is
 * present, so a bare `sortBy: {}` (a slice's initial state) is a 422.
 * Stripped here so every caller — table, refetches — is covered.
 */
export const stripEmptySortBy = (payload?: any) => {
	if (payload?.sortBy && !payload.sortBy.field) {
		const { sortBy, ...rest } = payload;
		return rest;
	}
	return payload;
};

/**
 * Allow-list picker. Instructor route: only students enrolled in one of the
 * owner's products come back.
 */
export const searchPromocodeStudentsRequest = (query: string) =>
	api.post<
		ApiResponse<
			{
				uuid: string;
				first_name: string;
				id: number;
				last_name: string;
				phone_number: string;
				username: string;
			}[]
		>
	>(`promocodes/students/search`, { query });

export class PromoCodesRequester implements CRUDBase<PromoCode> {
	private static instance: PromoCodesRequester;
	static getInstance() {
		if (!PromoCodesRequester.instance) {
			PromoCodesRequester.instance = new PromoCodesRequester();
		}
		return PromoCodesRequester.instance;
	}
	baseURL = 'promocodes/';
	getAll(
		payload?: GetAllMeta
	): Promise<AxiosResponse<ApiResponse<PromoCode[]>>>;
	getAll(payload: number): Promise<AxiosResponse<ApiResponse<PromoCode[]>>>;
	async getAll(
		payload?: any
	): Promise<AxiosResponse<ApiResponse<PromoCode[]>>> {
		return await api.post(`${this.baseURL}fetch`, stripEmptySortBy(payload));
	}
	get(id: string): Promise<AxiosResponse<ApiResponse<PromoCode>>>;
	get(id: number): Promise<AxiosResponse<ApiResponse<PromoCode>>>;
	get(
		id: string | number,
		payload: GetSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<PromoCode>>>;
	async get(
		id: any,
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<PromoCode>>> {
		return await api.post(`${this.baseURL}get`, { id });
	}
	async create(
		payload: Omit<PromoCode, 'id'>
	): Promise<AxiosResponse<ApiResponse<PromoCode>>> {
		return await api.post(`${this.baseURL}`, payload);
	}
	async update(
		payload: PromoCode
	): Promise<AxiosResponse<ApiResponse<PromoCode>>> {
		return await api.put(`${this.baseURL}`, payload);
	}
	delete(id: number): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(id: string): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: string | number,
		payload: DeleteSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<any>>>;
	async delete(
		id: any,
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<any>>> {
		return await api.delete(`${this.baseURL}`, { data: { id } });
	}
}
